<template>
  <q-dialog ref="dialog" @hide="onDialogHide">
    <q-card style="min-width: 600px">
      <q-card-section>
        <h3 class="text-h6 q-ma-none text-center">عملیات کیف پول</h3>
        <q-btn
          flat
          dense
          rounded
          size=".7rem"
          icon="fal fa-times"
          color="red"
          class="absolute-top-right q-mt-md q-mr-md"
          label=""
          v-close-popup
        >
          <q-tooltip>بستن</q-tooltip>
        </q-btn>
      </q-card-section>

      <q-card-section>
        <p class="text-subtitle2">
          آیا برای انجام این عملیات مطمئن هستید؟
        </p>

        <ul>
          <li v-if="wallet.type === 'inc'">
            افزایش مقدار کیف پول به مبلغ <b>{{ wallet.amount.toLocaleString() }}</b> تومان
          </li>
          <li v-if="wallet.type === 'dec'">
            کاهش مقدار کیف پول به مبلغ <b>{{ wallet.amount.toLocaleString() }}</b> تومان
          </li>
        </ul>

      </q-card-section>

      <q-card-actions align="right">
        <q-btn text-color="black" color="white" unelevated label="انصراف" @click="onCancelClick" />
        <q-btn color="green-7" unelevated label="بله مطمئنم" @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script lang="js">
export default {
  name: 'WalletConfirmDialog',

  props: {
    /**
     * @type {WalletForm}
     */
    wallet: {}
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide()
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok')
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide()
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>

<style scoped>

</style>
